import { resource } from 'ember-resources';
import { remoteData } from 'reactiveweb/remote-data';
import * as Plot from '@observablehq/plot';
import { use } from 'ember-resources';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import LocationModel from 'bcl/models/location';
import setElement from 'bcl/modifiers/set-element';
import ItemModel from 'bcl/models/item';

interface DiagrammRenderPlotSignature {
  // The arguments accepted by the component
  Args: {
    startDate: Date | null;
    endDate: Date | null;
    selectedStat: string | null;
    location?: LocationModel;
    item?: ItemModel;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class DiagrammRenderPlotComponent extends Component<DiagrammRenderPlotSignature> {
  @use request = resource((hooks) =>
    remoteData(hooks, `/api/diagramm/${this.args.selectedStat}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        startDate: this.args.startDate,
        endDate: this.args.endDate,
        locationId: this.args.location?.id,
        itemId: this.args.item?.id,
      }),
    })
  );

  element: HTMLElement | null = null;

  @action
  setEle(element: HTMLElement) {
    this.element = element;
    this.render();
  }
  @action render() {
    const data = this.request.value.map((d: any) => ({
      Datum: new Date(d[1]),
      Menge: d[0],
    }));
    const plot = Plot.plot({
      marks: [
        Plot.ruleY([0]),
        Plot.lineY(data, {
          x: 'Datum',
          y: 'Menge',
          marker: true,
        }),
      ],
    });
    // const plot = Plot.rectY(
    //   { length: 10000 },
    //   Plot.binX({ y: 'count' }, { x: Math.random }),
    // ).plot();
    this.element.append(plot);
  }

  <template>
    {{#if this.request.isError}}
      <div class="text-red-500">
        Fehler beim Laden der Bestellungen:
        {{this.request.error}}
      </div>
    {{else if this.request.isLoading}}
      <div class="text-gray-500">Lade Bestellungen...</div>
    {{else if this.request.isResolved}}
      <div {{setElement this.setEle}}>
      </div>
    {{/if}}
  </template>
}
